var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"light":""}},[_c('router-view'),_c('ConfirmationDialog',{ref:"confirm"}),_c('ChoiceDialog',{ref:"choice"}),_c('Snackbar',{ref:"snackbar"}),_c('Save',{ref:"save"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }